
const k1utils = {
    isEmpty: function (value) {
        return value === "" || value === null || value === undefined || (typeof value === "object" && !Object.keys(value).length);
    },

    isDev: function() {
        return  (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
    },

    padLeft(nr, n, str) {
        return Array(n-String(nr).length+1).join(str||'0') + nr;
    },

    checkImage( image_url ) {
        if ( image_url === '') return "file";

        if ( image_url.includes( "instagram.com") ) {
            return "instagram";
        } else if ( image_url.includes( "pin.it") ) {
            return "pinterest";
        } else if ( image_url.includes( "postfiles.pstatic.net") ) {
            // 네이버에서 Copy 해온 이미지
            return "naver";
        } else if ( image_url.includes( "daumcdn.net") ) {
            // 다음에서 Copy 해온 이미지
            return "daum";
        } else if ( image_url.includes( "kakaocdn.net") ) {
            // 카카오에서 Copy 해온 이미지
            return "kakao";
        } else if ( image_url.toLowerCase().endsWith('jpg') || image_url.toLowerCase().endsWith('jpeg') || image_url.toLowerCase().endsWith('png') ) {
            return "_normal_";
        }

        return undefined;

    },
    cutImage(image_url, file_idx) {

        if ( image_url === '') {
            return process.env.REACT_APP_API_SERVER_URL + '/front/file2?file_idx=' + file_idx + '&type=SMALL';
        }

        if ( image_url.includes( "instagram.com") ) {
            // https://www.instagram.com/p/CGgpLlYJz6F/?utm_source=ig_web_copy_link
            // https://www.instagram.com/p/CGzMYl6plhR/?utm_source=ig_web_button_share_sheet
            // let lastIndexOfSlash = image_url.lastIndexOf('/');
            // console.log ( lastIndexOfSlash );
            // console.log ( image_url.substr(0, lastIndexOfSlash) + '/media/?size=l');
            // return image_url.substr(0, lastIndexOfSlash) + '/media/?size=l';

            // 시도는 좋았으나, 안됨. 400 Bad Request 발생
            return "img/instagram.png";
        } else if ( image_url.includes( "pin.it") ) {
            return "img/pinterest.png";
        } else if ( image_url.includes( "postfiles.pstatic.net") ) {
            // 네이버에서 Copy 해온 이미지
            return image_url;
        } else if ( image_url.includes( "daumcdn.net") ) {
            return image_url;
        } else if ( image_url.includes( "kakaocdn.net") ) {
            return image_url;
        } else if ( image_url.toLowerCase().endsWith('jpg') || image_url.toLowerCase().endsWith('jpeg') || image_url.toLowerCase().endsWith('png') ) {
            return image_url;
        }

        return undefined;
    },
    phoneNumberFormat(str) {
        if (str.match(/^\d{11}$/))
            return str.substr(0, 3) + "-" + str.substr(3, 4) + "-" + str.substr(7, 4);
        else
            return str;

    },

    zerofeed(num) {
        return  (num < 10) ? "0"+num:num;
    },

    toSmallFileUrl (file_idx) {return process.env.REACT_APP_API_SERVER_URL + '/front/file2?file_idx=' + file_idx + '&type=SMALL' },

    toBigFileUrl (file_idx) {return process.env.REACT_APP_API_SERVER_URL + '/front/file2?file_idx=' + file_idx + '&type=BIG' },

    priceFormat(price) {
        if(price) {
            return price.toLocaleString('ko-KR')
        }else {
            return price;
        }
    }

}
export default k1utils;